
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  computed: {
    width() {
      return (this as any).widthProp ? (this as any).widthProp : "17";
    },
    height() {
      return (this as any).heightProp ? (this as any).heightProp : "21";
    }
  }
})
export default class IcoEndoso extends Vue {
  @Prop(String) readonly widthProp: string;
  @Prop(String) readonly heightProp: string;
}
